import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/connexion',
        name: 'login',
        component: () => import('@/pages/auth/login'),
        meta: {
            title: `Connexion - ${config.default_page_title}`,
        }
    },

    {
        path: '/impersonate',
        name: 'impersonate',
        component: () => import('@/pages/auth/impersonate'),
        meta: {
            title: `Impersonate - ${config.default_page_title}`,
        }
    },

    {
        path: '/inscription',
        name: 'register',
        component: () => import('@/pages/auth/register'),
        meta: {
            title: `Inscription - ${config.default_page_title}`,
        }
    },

    {
        path: '/password/reset',
        name: 'forgot-password',
        component: () => import('@/pages/auth/forgot-password'),
        meta: {
            title: `Mot de passe oublié - ${config.default_page_title}`,
        }
    },

    {
        path: '/password/reset/:token',
        name: 'forgot-password-reset',
        component: () => import('@/pages/auth/forgot-password-reset'),
        meta: {
            title: `Mot de passe oublié - ${config.default_page_title}`,
        }
    },

    {
        path: '/email/verify',
        name: 'email-verify',
        component: () => import('@/pages/auth/email-verify'),
        meta: {
            title: `Vérifiez votre adresse email - ${config.default_page_title}`,
        },
        children: [
            {
                path: ':id/:hash',
                name: 'email-verify.action',
                component: () => import('@/pages/auth/email-verify'),
                meta: {
                    title: `Vérifiez votre adresse email - ${config.default_page_title}`,
                }
            },
        ]
    },

    {
        path: '/welcome/:token',
        name: 'welcome',
        component: () => import('@/pages/auth/onboarding'),
        meta: {
            title: `Inscription - ${config.default_page_title}`,
        }
    },

    {
        path: '/canceled-invitation',
        name: 'canceled-invitation',
        component: () => import('@/pages/canceled-invitation'),
        meta: {
            title: `Votre invitation est annulée - ${config.default_page_title}`,
        }
    },

    {
        path: '/already-invited',
        name: 'already-invited',
        component: () => import('@/pages/already-invited'),
        meta: {
            title: `Invitation existante pour cet email - ${config.default_page_title}`,
        }
    },

    {
        path: '/banned',
        name: 'banned',
        component: () => import('@/pages/banned'),
        meta: {
            title: `Votre compte est banni - ${config.default_page_title}`,
        }
    },
]

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior() {
        return { left: 0, top: 0 }
    },
    routes
});

router.beforeEach((to, from, next) => {
    // 404 redirect
    if (!to.matched.length) {
        return next('/404');
    }

    // Handle pages titles, source: https://alligator.io/vuejs/vue-router-modify-head
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
    const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))
    if (!nearestWithMeta) return next()
    nearestWithMeta.meta.metaTags.map(tagDef => {
        const tag = document.createElement('meta')

        Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key])
        })

        tag.setAttribute('data-vue-router-controlled', '')

        return tag
    })
    .forEach(tag => document.head.appendChild(tag))

    next()
})

export default router
